import { Flex, useBreakpointValue } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { AuthBanner } from '../AuthBanner';

export const AuthPageBody = ({ children }: PropsWithChildren) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  } as const);

  return (
    <Flex flex={1}>
      {!isMobile ? (
        <Flex flex={0.9} align='stretch' justify='stretch'>
          <AuthBanner />
        </Flex>
      ) : null}

      <Flex flex={1} align='stretch' justify='stretch'>
        {children}
      </Flex>
    </Flex>
  );
};
